var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"margin-top":"40px","margin-bottom":"40px"}},[_c('h3',{staticClass:"index-title"},[_vm._v(_vm._s(_vm.title))]),_c('p',{staticClass:"index-desc"},[_vm._v(_vm._s(_vm.desc))])])}
var staticRenderFns = []

export { render, staticRenderFns }